<template>
    <div class="terms">
        <div class="top-bar">
            <h1>Talki - Eliminar cuenta</h1>
        </div>
        <div class="container">
            <p><strong>I. INTRODUCCIÓN</strong></p>
            <p>La aplicación Talki recopila información personal del usuario, incluyendo su nombre y dirección de
                correo electrónico.
                El usuario tiene la facultad de eliminar sus datos de la aplicación en cualquier momento, según su
                discreción y necesidad.</p>

            <p><strong>II. INICIA SESIÓN</strong></p>
            <p>Dirigete al siguiente enlace e inicia sesión: <a href="https://talki-3590a.web.app/"
                    target="_blank">Inicia sesión
                    aquí</a></p>

            <p><strong>III. ELIMINAR CUENTA</strong></p>
            <p>Una vez iniciada la sesión, haga clic en el siguiente botón para eliminar sus datos. Es importante
                destacar que esta opción es crítica y no es posible recuperar la cuenta una vez eliminada. En
                consecuencia, todos los datos y progresos en Talki se perderán irremediablemente.</p>

            <button class="button button2" @click="showDialog()" style="background-color: red;">Eliminar cuenta</button>
        </div>

        <dialog id="sureDialog">
            <p>¿Estas seguro de eliminar tu cuenta?</p>
            <div class="dialog-flex">
                <button class="button button2" style="background-color: var(--red);"
                    @click="closeDialog()">Cancelar</button>
                <button class="button button2" @click="deleteUser()">Eliminar</button>
            </div>
        </dialog>

        <dialog id="notLogged">
            <p>Primero inicia sesión</p>
            <div class="dialog-flex">
                <button class="button button2" style="background-color: var(--red);"
                    @click="closeDialog()">Cerrar</button>
            </div>
        </dialog>

        <dialog id="completeDialog">
            <p>Acción completada</p>
            <div class="dialog-flex">
                <button class="button button2" @click="goToRoute()">Regresar</button>
            </div>
        </dialog>
    </div>
</template>

<script>
import router from "@/router";
export default {
    name: "DeleteView",
    data() {
        return {
            section: null,
            sectionData: {
                name: "",
                visible: false,
            },
        };
    },
    methods: {
        async deleteUser() {
            try {
                var userId = localStorage.getItem("userId");
                await this.$axios.delete(
                    "users/" +
                    userId
                );
                localStorage.removeItem("token");
                localStorage.removeItem("userId");
                var completeDialog = document.getElementById("completeDialog");
                completeDialog.showModal();
                //console.log("Respuesta del servidor:", response.data);
            } catch (error) {
                //console.error("Error al realizar la solicitud GET:", error);
            }
        },
        showDialog() {
            var userId = localStorage.getItem("userId");
            if (userId == null) {
                var auxDialog = document.getElementById("notLogged");
                auxDialog.showModal();
                return;
            }
            else {
                var otherDialog = document.getElementById("sureDialog");
                otherDialog.showModal();
            }
        },
        closeDialog() {
            var userId = localStorage.getItem("userId");
            console.log(userId);
            if (userId == null) {
                var auxDialog = document.getElementById("notLogged");
                auxDialog.close();
                return;
            }
            else {
                var otherDialog = document.getElementById("sureDialog");
                otherDialog.close();
            }
        },

        goToRoute() {
            router.push("/");
        },
    },
};
</script>

<style scoped>
html {
    margin: 0;
}

body {
    font-family: 'Manrope', sans-serif;
    margin: 0;
}

.top-bar {
    background-color: var(--main-color);
    padding: 20px;
    margin-bottom: 10px;
}

.top-bar h1 {
    margin: 0;
    color: white;
    letter-spacing: 1.5px;
    font-weight: bold;
}

.container {
    width: 70%;
    margin: 30px auto;
}


h1 {
    text-align: center;
}

h2 {
    font-size: 28px;
}

h3 {
    font-size: 24px;
    margin-bottom: 8px;
}

p {
    font-size: 20px;
    text-align: justify;
    margin: 0;
    margin-bottom: 20px;
}

p strong {
    font-size: 24px;
}

dialog {
    border: none !important;
    border-radius: 10px;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    -ms-border-radius: 10px;
    -o-border-radius: 10px;
    box-shadow: 0 0 #0000, 0 0 #0000, 0 25px 50px -12px rgba(0, 0, 0, 0.25);
    padding: 2rem;
}

dialog p {
    font-size: 20px;
}

.dialog-flex {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
}

.button {
    align-self: flex-end;
    margin: 10px 0;
    background-color: transparent;
    color: var(--main-color);
    border: none;
    padding: 10px;
    cursor: pointer;
    font-size: 18px;
    letter-spacing: 1.2px;
    transition: all ease-out 0.2s;
    -webkit-transition: all ease-out 0.2s;
    -moz-transition: all ease-out 0.2s;
    -ms-transition: all ease-out 0.2s;
    -o-transition: all ease-out 0.2s;
}

.button:hover {
    transform: scale(1.05);
    -webkit-transform: scale(1.05);
    -moz-transform: scale(1.05);
    -ms-transform: scale(1.05);
    -o-transform: scale(1.05);
}

.button2 {
    background-color: var(--main-color);
    color: var(--white);
    border-radius: 18px;
    -webkit-border-radius: 18px;
    -moz-border-radius: 18px;
    -ms-border-radius: 18px;
    -o-border-radius: 18px;
}
</style>